import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { DataSource } from '@angular/cdk/table';

import { ISnListItem } from './list.interfaces';

export class SnListDataSource<M extends ISnListItem> extends DataSource<M> {
  private readonly _dataMap = new Map<string, M>();
  private readonly _updated$ = new BehaviorSubject<M[]>([]);

  private readonly _itemsDeleted$ = new Subject<M[]>();

  constructor() {
    super();
  }

  get data(): M[] {
    return this._updated$.value;
  }

  get updated$(): Observable<M[]> {
    return this._updated$.asObservable();
  }
  get itemsDeleted$(): Observable<M[]> {
    return this._itemsDeleted$.asObservable();
  }

  public trackById(index: number, item: ISnListItem): string {
    return item.id;
  }

  public insertItem(...items: M[]): void {
    items.forEach((item) => {
      this._dataMap.delete(item.id);
      this._dataMap.set(item.id, item);
    });
    this._updateData();
  }

  public insertItemToStart(...items: M[]): void {
    const data = this.data.slice();
    data.unshift(...items);

    this._dataMap.clear();
    this.insertItem(...data);
  }

  public updateItem(...items: M[]): void {
    items.forEach((item) => {
      if (this._dataMap.has(item?.id)) {
        this._dataMap.set(item.id, item);
      }
    });
    this._updateData();
  }

  public deleteItem(...items: M[]): void {
    items.forEach((item) => this._dataMap.delete(item.id));
    this._updateData();

    this._itemsDeleted$.next(items);
  }

  public clear(): void {
    this._dataMap.clear();
    this._updateData();
  }

  public destroy(): void {
    this._updated$.complete();
    this._itemsDeleted$.complete();
  }

  public connect(): Observable<M[]> {
    return this.updated$;
  }

  public disconnect(): void {}

  private _updateData(): void {
    this._updated$.next(Array.from(this._dataMap.values()));
  }
}
